export const RunningSessionError = 32605
export const ClientConnectedError = 32606
export const BoardStateException = 32607
